// removed by extract-text-webpack-plugin
module.exports = {"root":"cl-kits-order-success--root--23Phc59w","title":"cl-kits-order-success--title--I-vKJHXc","subtitle":"cl-kits-order-success--subtitle--qmtKqWvB","actions":"cl-kits-order-success--actions--2piGR4Zq","mainActions":"cl-kits-order-success--mainActions--APMNHZgn"};


//////////////////
// WEBPACK FOOTER
// ./components/cl-kits-order-success/styles.css
// module id = ./components/cl-kits-order-success/styles.css
// module chunks = 0